import React from 'react';
import { toAbsoluteUrl } from '../../../../../../_metronic';

const FlagIcon = ({path, label}) => {
  return (
    <div>
      <img
        src={toAbsoluteUrl(path)}
        alt=""
        width="20px"
        height="20px"
      />{' '}
      {label}
    </div>
  );
};

export default FlagIcon;
